import React from 'react';

import styled, { keyframes } from 'styled-components';

import { Modal as ModalMui } from '@mui/material';
import { ModalProps as ModalPropsMui } from '@mui/material';

import { Box } from 'components/@ux/box';

const fadeIn = keyframes` 
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Scrollable = styled(Box)`
  height: 100vh;
  overflow-y: auto;
  overflow-x: none;
  outline: none;
`;

const StyledModal = styled(ModalMui)`
  animation: ${fadeIn} 0.4s linear;
`;

export interface ModalProps extends Omit<ModalPropsMui, 'children' | 'open'> {
  open?: boolean;
  children: React.ReactNode;
}

export const Modal = ({ children, open = true, ...remainderProps }: ModalProps): JSX.Element => (
  <StyledModal data-testid="Modal" open={open} {...remainderProps}>
    <Scrollable data-testid="Modal_Scrollable">
      <Box centeredContent minHeight="100%">
        <Box bg="#FFFFFF" borderRadius="4px" overflow="hidden">
          {children}
        </Box>
      </Box>
    </Scrollable>
  </StyledModal>
);
